// extracted by mini-css-extract-plugin
module.exports = {"file":"platilloUpload_file__mSPBT","submit":"platilloUpload_submit__1MIfY"};